/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const searchPages = {
    FindGroupingPage: () => import('@/search/FindGroupingPage'),
    playSearch: () => import('@/voice/playSearch'),
    Search: () => import('@/search/Search'),
    SearchSeeMorePage: () => import('@/search/SearchSeeMorePage'),
    searchService: () => import('@/search/searchService'),
}
